export default __webpack_public_path__ + "static/media/aspas.726c5c29.glb";